import script from "./BrandPortfolioAggregateMixin.vue?vue&type=script&lang=js"
export * from "./BrandPortfolioAggregateMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__